import React from 'react';
import { isNative } from '../Helper';


const LineAddNotify = (props) => {
    let { lineAccount } = props
    return !window.liff.isInClient() && !isNative() && <div className="p20 has-text-centered">เพื่อความสะดวกในการติดต่อกับเรา เราขอแนะนำให้คุณใช้งานผ่าน Line Application {lineAccount}<br /><a href={`https://line.me/R/ti/p/%40${lineAccount}`} className="button is-success is-small">Add Line @{lineAccount}</a></div>;
}
export default LineAddNotify